// Raster work remains separate from vector ProcessingTool implementations.
// The worker owns decoding and display-pyramid preparation so large TIFF files
// never have to be read on the Vue/UI thread.
export class RasterEngine {
  constructor(workerPool) {
    this.workerPool = workerPool
  }

  loadGeoTiff({ name, fileName, fileSize, buffer }) {
    return this.workerPool.run('import-geotiff', { name, fileName, fileSize, buffer }, [buffer])
  }

  getMetadata(dataset) {
    return {
      width: dataset.width,
      height: dataset.height,
      bands: dataset.bands,
      dtype: dataset.dtype,
      nodata: dataset.nodata,
      extent: dataset.extent,
      resolution: dataset.resolution,
      crs: dataset.crs
    }
  }
}
